import { IAppState, TActions } from '../../../common/state';
import { jq, jqs } from '../../../json_query';

export const IDeveloperTypeChangedActionType = 'filters/developer/DEVELOPER_TYPE_CHANGED';
export const IPromoChangedActionType = 'filters/developer/PROMO_CHANGED';

export interface IDeveloperTypeChangedAction {
  type: 'filters/developer/DEVELOPER_TYPE_CHANGED';
  value: boolean | undefined;
}

export interface IPromoChangedAction {
  type: 'filters/developer/PROMO_CHANGED';
  value: boolean;
}

export function changeDeveloperType(value: boolean | undefined): IDeveloperTypeChangedAction {
  return {
    type: IDeveloperTypeChangedActionType,
    value,
  };
}

export function changePromoCheckbox(value: boolean): IPromoChangedAction {
  return {
    type: IPromoChangedActionType,
    value,
  };
}

export function developerTypeReducer(state: IAppState, action: TActions): IAppState {
  switch (action.type) {
    case IDeveloperTypeChangedActionType:
      return {
        ...state,
        filters: {
          ...state.filters,
          jsonQuery: jq(state.filters.jsonQuery).setDeveloperType(action.value),
        },
      };

    case IPromoChangedActionType:
      return {
        ...state,
        filters: {
          ...state.filters,
          jsonQuery: jq(state.filters.jsonQuery).setPromo(action.value),
        },
      };

    case 'filters/tags/TAG_REMOVED':
      if (action.tag.type === 'advanced-developer-type') {
        return {
          ...state,
          filters: {
            ...state.filters,
            jsonQuery: jq(state.filters.jsonQuery).setDeveloperType(undefined),
          },
        };
      }

      if (action.tag.type === 'advanced-developer-promo') {
        return {
          ...state,
          filters: {
            ...state.filters,
            jsonQuery: jq(state.filters.jsonQuery).setPromo(false),
          },
        };
      }

      return state;

    case 'filters/tags/ALL_TAGS_REMOVED':
      return {
        ...state,
        filters: {
          ...state.filters,
          jsonQuery: jqs(state.filters.jsonQuery, [
            jsonQuery => jq(jsonQuery).setDeveloperType(undefined),
            jsonQuery => jq(jsonQuery).setPromo(false),
          ]),
        },
      };

    default:
      return state;
  }
}
